import React from 'react';

import FreestarAd, { type AdConfig } from 'components/FreestarAd';

export type { AdConfig };

interface GoogleDFPProps {
  adConfig: AdConfig;
  useUuid?: boolean;
}

const GoogleDFP: React.FC<GoogleDFPProps> = (props) => <FreestarAd {...props} />;

export default GoogleDFP;
